'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _reactRedux = require('react-redux');
var _glamorous = require('glamorous');
var _reduxWindow = require('redux-window');
var _themes = require('@marmalade/themes');
var headerTheme = _themes.componentThemes.header.headerTheme;
var withHeaderThemeAndWidth = function withHeaderThemeAndWidth(Component) {
  return (0, _glamorous.withTheme)((0, _reactRedux.connect)(function (state, ownProps) {
    return {
      width: (0, _reduxWindow.getWidth)(state),
      theme: headerTheme(ownProps.theme)
    };
  })(Component));
};
exports.default = withHeaderThemeAndWidth;